import { Injectable, computed, signal } from '@angular/core';

export type PreferenciaTema = 'claro' | 'escuro' | 'sistema';
export type TemaEfetivo = 'claro' | 'escuro';

export const CHAVE_TEMA = 'km.tema';
const CONSULTA_ESCURO = '(prefers-color-scheme: dark)';

function lerPreferencia(): PreferenciaTema {
  try {
    const v = localStorage.getItem(CHAVE_TEMA);
    if (v === 'claro' || v === 'escuro' || v === 'sistema') {
      return v;
    }
  } catch {
    // localStorage indisponivel (modo privado): usa o padrao
  }
  return 'sistema';
}

function consultaSistema(): MediaQueryList | null {
  return typeof matchMedia === 'function' ? matchMedia(CONSULTA_ESCURO) : null;
}

function aplicarAtributo(tema: TemaEfetivo): void {
  document.documentElement.setAttribute('data-bs-theme', tema === 'escuro' ? 'dark' : 'light');
}

function resolver(pref: PreferenciaTema, sistemaEscuro: boolean): TemaEfetivo {
  if (pref === 'sistema') {
    return sistemaEscuro ? 'escuro' : 'claro';
  }
  return pref;
}

/** Aplica o tema antes do bootstrap da app, evitando flash de tema errado. */
export function aplicarTemaInicial(): void {
  aplicarAtributo(resolver(lerPreferencia(), consultaSistema()?.matches ?? false));
}

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly mql = consultaSistema();
  private readonly sistemaEscuro = signal(this.mql?.matches ?? false);

  readonly preferencia = signal<PreferenciaTema>(lerPreferencia());
  readonly efetivo = computed<TemaEfetivo>(() =>
    resolver(this.preferencia(), this.sistemaEscuro()),
  );

  constructor() {
    this.mql?.addEventListener('change', (e) => {
      this.sistemaEscuro.set(e.matches);
      aplicarAtributo(this.efetivo());
    });
    aplicarAtributo(this.efetivo());
  }

  definir(pref: PreferenciaTema): void {
    this.preferencia.set(pref);
    try {
      localStorage.setItem(CHAVE_TEMA, pref);
    } catch {
      // sem persistencia: mantem so em memoria
    }
    aplicarAtributo(this.efetivo());
  }

  /** Alterna entre claro e escuro a partir do tema efetivo atual. */
  alternar(): void {
    this.definir(this.efetivo() === 'escuro' ? 'claro' : 'escuro');
  }
}
